var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['js-menu-mobile', { active: _vm.$store.state.popUpHeaderMenu }],on:{"click":function($event){return _vm.menuClick()}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-icon"},[_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }